import { render, staticRenderFns } from "./VideoSocialClip.vue?vue&type=template&id=2376671c&scoped=true"
import script from "./VideoSocialClip.vue?vue&type=script&lang=js"
export * from "./VideoSocialClip.vue?vue&type=script&lang=js"
import style0 from "./VideoSocialClip.vue?vue&type=style&index=0&id=2376671c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2376671c",
  null
  
)

export default component.exports